import { HttpEvent, HttpHandlerFn, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NetworkService } from '../service/network/network.service';

export function networkStatusInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const networkService = inject(NetworkService);
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  if (isBrowser && !networkService.getCurrentStatus()) {
    // console.log('Interceptor: No hay conexión a internet');
    return throwError(() => new Error('No hay conexión a internet'));
  }

  return next(req).pipe(
    timeout(30000),
    catchError(error => {
      // console.log('Interceptor error:', error);

      // Modificamos la detección de errores de red para ser más específica
      const isNetworkError =
        (error instanceof TypeError && error.message.includes('Failed to fetch')) ||
        (error instanceof HttpErrorResponse &&
          (error.status === 0 &&
            (error.error instanceof ProgressEvent ||
              error.message?.includes('Unknown Error'))));

      if (isNetworkError && isBrowser) {
        // console.log('Detectado error de red, actualizando estado a offline');
        networkService.isOnline.next(false);
        return throwError(() => new Error('No hay conexión a internet'));
      }

      return throwError(() => error);
    })
  );
}
